import { Button, Col, DatePicker, Form, Input, Row, Select } from "antd";
import moment from "moment";
import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { getflagCategory } from "../../models/category";
import { DateTimeFormat } from "../../models/datetime";
import { Department } from "../../models/department";
import { User } from "../../models/user";
import { getStorage, selectStorage } from "../durgsystem/durgsystemSlice";
import { SupplierModal as SupplierSaveModal } from '../wms/modal'
import {
  DepartmentDate,
  savePutstorage,
  selectDepartData,
} from "../putstorage/putstorageSlice";
import {
  getUserName,
  selectstoreId,
  setSelectId,
  sleectUserData,
} from "../putstorelist/putstorelistSlice";
import {
  selectUserDepartmentId,
  selectUserId,
} from "../../app/applicationSlice";
import { PlusOutlined } from "@ant-design/icons";
import { DurgModal } from "../durgsystem/modal";
import { SupplierModal } from "../savebusiness/modal";
import { setCurrent } from "../wms/supplierSlice";

const { Option } = Select;

const layout = {
  labelCol: { span: 7 },
  wrapperCol: { span: 17 },
};

export interface PurchaseInventoryEntryCheckRef {
  save: () => void
  getValues: () => any
}

const PurchaseInventoryEntryCheckQuerys = (props: {
  category: any
  detailList: any
  onValueChange: (params: any) => void
}, ref: React.Ref<PurchaseInventoryEntryCheckRef>) => {
  const [form] = Form.useForm();

  const dispatch = useDispatch();

  const [isModalVisible, setIsModalVisible] = useState(false);

  const [ismodalVisible, setIsmodalVisible] = useState(false);

  const [tenantSupplierId, setTenantSupplierId] = useState(0)

  const durgsystemData: any = useSelector(selectStorage);

  const departmentData = useSelector(selectDepartData);

  const userData = useSelector(sleectUserData);

  const userId = useSelector(selectUserId);

  const departmentId = useSelector(selectUserDepartmentId);

  const [isVisible, setIsVisible] = useState(false);

  const [isFirst, setIsFirst] = useState(false);

  // 组装表单参数（含库房名称/部门名称/业务人员姓名等中文名）
  const buildParams = (values: any) => {
    const storehouseName =
      (durgsystemData.find(
        (d: any) => d.storehouseId == values.storehouseId
      ) as any)?.storehouseName || "";
    const departmentName =
      (departmentData.find(
        (d: any) => d.id == values.departmentId
      ) as any)?.name || "";
    const userName =
      (userData.find((u: any) => u.id == values.userId) as any)
        ?.name || "";
    const recepitsDate = values.recepitsDate ? moment(values.recepitsDate).format(DateTimeFormat) : '';
    return {
      ...values,
      storehouseName,
      departmentName,
      userName,
      category: props.category,
      recepitsDate,
    };
  };

  useImperativeHandle(ref, () => ({
    save: () => {
      form.submit()
    },
    getValues: () => buildParams(form.getFieldsValue()),
  }))

  useEffect(() => {
    dispatch(
      getStorage({ current: 1, flag: getflagCategory(props.category) })
    );
    dispatch(DepartmentDate({ current: 1, size: 1000 }));

    form.setFieldsValue({
      recepitsDate: moment(),
    });
    if (userId || departmentId) {
      dispatch(getUserName(departmentId));
      form.setFieldsValue({
        departmentId: Number(departmentId),
        userId: Number(userId),
      });
    }
  }, []);

  useEffect(() => {
    // 库房名称回填
    if (durgsystemData?.length && isFirst) {
      form.setFieldsValue({
        storehouseId: durgsystemData?.[0]?.storehouseId
      })
    }
  }, [durgsystemData])

  useEffect(() => {
    //  回填数据
    if (props?.detailList) {
      const detail = props?.detailList
      if (JSON.stringify(detail) !== '{}') {
        form.setFieldsValue({
          storehouseId: detail.storehouseId > 0 ? Number(detail.storehouseId) : form.getFieldValue('storehouseId') ? Number(form.getFieldValue('storehouseId')) : '',
          storehouseName: detail.storehouseName,
          recepitsNumber: detail.recepitsNumber ? detail.recepitsNumber : form.getFieldValue('recepitsNumber'),
          supplierName: detail.supplierName ? detail.supplierName : form.getFieldValue('supplierName'),
          invoiceNumber: detail.invoiceNumber > 0 ? detail.invoiceNumber : form.getFieldValue('invoiceNumber'),
          departmentId: detail.departmentId > 0 ? Number(detail.departmentId) : form.getFieldValue('departmentId') ? Number(form.getFieldValue('departmentId')) : '',
          departmentName: detail.departmentName,
          userId: detail.userId > 0 ? Number(detail.userId) : form.getFieldValue('userId') ? Number(form.getFieldValue('userId')) : '',
          userName: detail.userName,
          recepitsDate: detail.recepitsDate ? moment(detail.recepitsDate) : form.getFieldValue('recepitsDate') || moment(),
          remark: detail.remark ? detail.remark : form.getFieldValue('remark'),
        })
      }
    } else {
      form.setFieldsValue({
        recepitsDate: moment(),
      })
    }
  }, [props.detailList])


  return (
    <div>
      <div>
        <Form
          {...layout}
          form={form}
          name="control-hooks"
          autoComplete="off"
          onFinish={() => {
            form.validateFields().then((values) => {
              props?.onValueChange && props?.onValueChange(buildParams(values))
            });
          }}
        >
          <Row>
            <Col span={6}>
              <Col style={{ position: 'relative' }}>
                <Form.Item
                  name="storehouseId"
                  label="库房名称"
                  rules={[
                    {
                      required: true,
                      message: "库房名称不能为空,请输入正确的值。",
                    },
                  ]}
                >
                  <Select placeholder="药房" allowClear style={{ width: '66%' }}>
                    {durgsystemData.map((v: any, i: number) => {
                      return (
                        <Option value={Number(v.storehouseId)} key={i}>
                          {v.storehouseName}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
                <Col style={{ position: 'absolute', top: 0, right: 0 }} >
                  <Button
                    type='link'
                    icon={<PlusOutlined />}
                    onClick={() => setIsVisible(true)}
                  >
                    新增
                  </Button>
                </Col>
              </Col>

            </Col>
            <Col span={6}>
              <Form.Item
                name="recepitsNumber"
                label="采购单号"
                rules={[{ max: 256, message: "最大256位!" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="supplierName"
                label="供应商"
                rules={[
                  {
                    required: true,
                    message: "供应商不能为空,请输入正确的值。",
                  },
                ]}
              >
                <Input
                  onClick={() => {
                    setIsModalVisible(true);
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="invoiceNumber"
                label="发票号"
                rules={[{ max: 256, message: "最大256位!" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="departmentId"
                label="业务部门"
                rules={[
                  {
                    required: true,
                    message: "业务部门不能为空,请输入正确的值。",
                  },
                ]}
              >
                <Select
                  placeholder="业务部门"
                  allowClear
                  onSelect={(key: any) => {
                    form.setFieldsValue({
                      userId: undefined,
                    });
                    dispatch(getUserName(key));
                  }}
                >
                  {departmentData.map((v: Department) => {
                    return (
                      <Option value={Number(v.id)} key={Number(v.id)}>
                        {v.name}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="userId"
                label="业务人员"
                rules={[
                  {
                    required: true,
                    message: "业务人员不能为空,请输入正确的值。",
                  },
                ]}
              >
                <Select showSearch placeholder="业务人员" allowClear>
                  {userData.map((v: User) => {
                    return (
                      <Option value={Number(v.id)} key={Number(v.id)}>
                        {v.name}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="recepitsDate"
                label="业务日期"
                rules={[
                  {
                    required: true,
                    message: "业务日期不能为空,请输入正确的值。",
                  },
                ]}
              >
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="remark"
                label="备注"
                rules={[{ max: 256, message: "最大256位!" }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
      <SupplierSaveModal
        visible={ismodalVisible}
        supplierCategory={0}
        onOk={(companyName?: any) => {
          setIsmodalVisible(false)
          setIsModalVisible(false)
          form.setFieldsValue({
            supplierName: companyName,
          });
          dispatch(setCurrent(1))
        }}
        onCancel={() => {
          setIsmodalVisible(false)
          setIsModalVisible(true)
        }}
      />
      {/*  供应商 supplierCategory=0*/}
      <SupplierModal
        supplierCategory={0}
        visible={isModalVisible}
        // 新增供应商
        switchModal={() => {
          setIsModalVisible(false);
          setIsmodalVisible(true);
        }}
        onOk={() => {
          setIsModalVisible(false);
        }}
        onCancel={() => {
          setIsModalVisible(false);
        }}
        onRecord={(record) => {
          setTenantSupplierId(record.id)
          form.setFieldsValue({
            supplierName: record.companyName,
          });
        }}
      />
      <DurgModal
        visible={isVisible}
        onOk={() => {
          setIsVisible(false);
          setIsFirst(true)
          setTimeout(() => {
            dispatch(
              getStorage({ current: 1, flag: getflagCategory(props.category) })
            );
          }, 100)
        }}
        onCancel={() => {
          setIsVisible(false);
        }}
      />
    </div>
  );
};

export const PurchaseInventoryEntryCheckQuery = forwardRef(PurchaseInventoryEntryCheckQuerys)